module.exports = __webpack_public_path__ + "img/payment.bdb33d7e.png";